<template>
  <div class="simple-text-submit">
    <!-- 文本输入区域 -->
    <el-input
      type="textarea"
      v-model="content"
      :rows="18"
      placeholder="请输入内容..."
      class="textarea"
    ></el-input>
    <div style="margin: 10px 0">
      <div>示例：</div>
      <div class="">
        {"partnerTransactionID":"P2025082805541376804","transactionID":"PME25082800168330822",
        "paymentId":"BRYFJB8ODE9P0","storeId":0,"payMethod":"ATMCARD","payCode":"ATM","amount":37900000,"state":1,
        "desc":"Bug Goods","createDate":"2025-08-28
        04:54:12.000","secureHash":"cf4d30fee990d4a982261e53243e682587955bccf2afcbdfad789cb4326964da"}
      </div>
    </div>
    <!-- 提交按钮 -->
    <el-button
      type="primary"
      class="submit-btn"
      @click="handleSubmit"
      :disabled="!content.trim()"
    >
      提交
    </el-button>
  </div>
</template>

<script>
import { gateSupplyApi } from "@/utils/api";
export default {
  name: "SimpleTextSubmit",
  data() {
    return {
      // 文本框内容
      content: "",
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    // 提交处理
    handleSubmit() {
      // 获取.trim()处理后的内容（去除首尾空格）
      const submitContent = this.content.trim();

      if (!submitContent) {
        this.$message.warning("请输入内容后再提交");
        return;
      }

      console.log("提交的内容:", submitContent);

      let params = {
        content: submitContent,
        token: this.token,
      };

      gateSupplyApi(params).then((res) => {
        if (res.code == 200) {
          // 提交成功提示
          this.$message.success(res.msg);
          // 可选：提交后清空文本框
          this.content = "";
        } else {
          // 提交成功提示
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped >
.simple-text-submit {
  width: 100%;
  max-width: 800px;
  margin: 20px 0;
  padding: 0 20px;
}

.textarea {
  width: 100%;
  margin-bottom: 16px;
}

.submit-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
}
</style>
    